import React from 'react';
import {connect} from 'react-redux';

import {windowFocused, windowBlurred} from '~/modules/window/actions';
import mapDispatch from '~/misc/mapDispatch';

class Focus extends React.Component {
  componentDidMount() {
    const {blurred, focused, check} = this.props;

    if (check) {
      window.addEventListener('visibilitychange', check);
      return;
    }

    window.addEventListener('blur', blurred);
    window.addEventListener('focus', focused);
  }

  render() { // eslint-disable-line lodash/prefer-constant
    return null;
  }

  componentUnMount() {
    const {blurred, focused, check} = this.props;

    if (check) {
      window.removeEventListener('visibilitychange', check);
      return;
    }

    window.removeEventListener('blur', blurred);
    window.removeEventListener('focus', focused);
  }
}


export default connect(null, mapDispatch({
  focused: windowFocused,
  blurred: windowBlurred,
  check: 'hidden' in window.document && (() => {
    if (window.document.hidden) {
      return windowBlurred();
    }
    return windowFocused();
  }),
}))(Focus);



// WEBPACK FOOTER //
// ./src/components/root/Focus.js